import { render } from "./FlipCoinHistoryDetails.vue?vue&type=template&id=ac5b29d2"
import script from "./FlipCoinHistoryDetails.vue?vue&type=script&lang=js"
export * from "./FlipCoinHistoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__